import { CornerRadius } from '@picsart/design-system/foundation/cornerRadius';
import { Spacings } from '@picsart/design-system/foundation/spacings';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles(
  () => ({
    root: {},
    bannerHolder: {
      marginTop: Spacings.s40,
    },
    // Skeleton
    skeletonBannerHolder: {
      extend: 'bannerHolder',
      width: '100%',
      height: 412,
      // [mediaQuery(767)]: {
      '@media screen and (max-width: 767px)': {
        height: 450,
      },
      '& > i': {
        borderRadius: CornerRadius.r20,
      },
    },
  }),
  {
    name: 'list-with-pagination-and-cta',
  },
);

export default useStyles;
